import { render } from "./promotions.vue?vue&type=template&id=9c7755a6&scoped=true"
import script from "./promotions.vue?vue&type=script&lang=js"
export * from "./promotions.vue?vue&type=script&lang=js"

import "./promotions.vue?vue&type=style&index=0&id=9c7755a6&lang=scss"
import "./promotions.vue?vue&type=style&index=1&id=9c7755a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7755a6"]])

export default __exports__